/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { Container, Logo, Message } from './styles';
import { useConfig } from '@revenuewell/logic-config';
import { Button } from '@mui/material';
import { useDesktop } from '@revenuewell/logic-desktop';

export const NewAppAvailable: React.FC = () => {
  const { config } = useConfig();
  const { isDesktopApplication, isNewDesktopApp } = useDesktop();

  const onDownloadClick = async () => {
    if(isDesktopApplication() && !isNewDesktopApp()) {
      const ipcRenderer = window.require('electron').ipcRenderer;
      const response = await fetch(`${config.desktop.blobUrl}/desktop/latest.json`);
      const latestJson = await response.json();
      ipcRenderer.send('open-external-link', `${config.desktop.blobUrl}/desktop/${latestJson.path}`);
    }
  }

  return (
    <Container>
      <Logo />
      <Message>
        We're excited to announce that a new version of our desktop app is now available! This updated version includes
        a number of new features and improvements, including universal search.
      </Message>
      <Message>To download the latest version, simply click on the link below:</Message>
      <Button variant="contained" size="large" onClick={() => onDownloadClick()} style={{marginTop: '30px'}}>
        Download
      </Button>
    </Container>
  );
};
